import { render, staticRenderFns } from "./资料下载.vue?vue&type=template&id=fd77cc7c&scoped=true"
import script from "./资料下载.vue?vue&type=script&lang=js"
export * from "./资料下载.vue?vue&type=script&lang=js"
import style0 from "./资料下载.vue?vue&type=style&index=0&id=fd77cc7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd77cc7c",
  null
  
)

export default component.exports